import { render, staticRenderFns } from "./FamilyInformationFormView.vue?vue&type=template&id=dbb412c4&scoped=true&"
import script from "./FamilyInformationFormView.vue?vue&type=script&lang=js&"
export * from "./FamilyInformationFormView.vue?vue&type=script&lang=js&"
import style0 from "./FamilyInformationFormView.vue?vue&type=style&index=0&id=dbb412c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb412c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VForm,VRow})
